import { downloadFile, saveAs } from "@/utils/blob";
import styled from "@emotion/styled";
import { message } from "antd";
import dayjs, { isDayjs } from "dayjs";
import { ReactNode } from "react";
import { SafetyValveReport } from "../types/SafetyValveReport";

const JMDWarnings = styled.div`
  text-align: left;
  ul,
  ol {
    list-style: none;
    padding-left: 0;
    margin: 0;
    text-align: left;
  }
`;

const Bold = styled.span`
  font-weight: 600;
`;

export const handleJmdDownload = async (formValues: SafetyValveReport) => {
  const response = await downloadFile("/tag_machine_template.jmd");
  if (!response) {
    message.error("Something went wrong, please try again later.");
    return;
  }
  const content = (await response?.json()) as {
    Elements: { Name: string; Text: string }[];
  };

  const tagMachineMap: Record<string, string | number | null | undefined> = {
    "VV#": formValues.vVVNumber,
    "Make ": formValues.vManufacturer?.toLocaleUpperCase(),
    "Model #": formValues.vModelNumber,
    Size: formValues.vValveSize,
    "Set Pressure ": `${formValues.vSetPressure} ${formValues.vUnit}`,
    "Back pressure ": `${formValues.vBackPressure} ${formValues.vUnit}`,
    "Serial #": formValues.vSerialNumber,
    "Date ":
      isDayjs(formValues.tDateTested) ||
      (formValues.tDateTested &&
        typeof formValues.tDateTested === "string" &&
        dayjs(formValues.tDateTested).isValid())
        ? dayjs(formValues.tDateTested).format("MMM/YY").toLocaleUpperCase()
        : formValues.tDateTested,
    "Capacity ": formValues.vCapacity,
    CDTP: `${formValues.tCDTP} ${formValues.vUnit}`,
    "PSV #": formValues.vPSVNumber,
    "CRN #": formValues.vCRNNumber,
  };
  const warnings: ReactNode[] = [];
  Object.entries(tagMachineMap).forEach(([key, value]) => {
    const element = content.Elements.find((el) => el.Name === key);
    if (element) {
      element.Text = String(value ?? "");
      if (!value) {
        warnings.push(
          <p>
            <Bold>{key}</Bold> is empty.
          </p>
        );
      }
    }
  });

  const blob = new Blob([JSON.stringify(content, null, 2)]);

  const vvNumberForFilename = (formValues.vVVNumber ?? "Unknown VV #").replace(
    /[^a-zA-Z0-9-_]/g,
    "_"
  );

  saveAs(blob, `Tag machine - ${vvNumberForFilename}.jmd`);

  if (warnings.length === 0) {
    message.success("The .jmd file was generated successfully.");
  }
  if (warnings.length > 0) {
    const durationInSeconds = 5;
    message.warning(
      <JMDWarnings>
        The .jmd file was generated with the following warnings:
        <ul>
          {warnings.map((warning) => (
            <li key={Math.random()}>{warning}</li>
          ))}
        </ul>
      </JMDWarnings>,
      durationInSeconds
    );
  }
};
